function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import styles from './DatePicker.module.sass';

const DatePicker = props => {
  const {
    name,
    className,
    value,
    dateFormat,
    ...inputProps
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['wrap-datepicker']
  }, name && /*#__PURE__*/React.createElement("h5", {
    className: styles['label']
  }, name), /*#__PURE__*/React.createElement(ReactDatePicker, _extends({
    className: `${styles['input-label-style']}`,
    name: name,
    showPopperArrow: false,
    selected: value
  }, inputProps, {
    dateFormat: dateFormat || "yyyy-MM-dd"
  })));
};

export default DatePicker;